import { render, staticRenderFns } from "./CuponCard.vue?vue&type=template&id=c0b07ca6&"
import script from "./CuponCard.vue?vue&type=script&lang=js&"
export * from "./CuponCard.vue?vue&type=script&lang=js&"
import style0 from "./CuponCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports